/**
 * @author 戴旭
 * @createDate 2023/02/28 15:29:41
 * @updateDate 2023/02/28 15:29:41
 * @description: 辖区关系
 */

const jurisRelationsRouter = [
  // 商业备案
  {
    path: '/jurisdictionSystem/bussiness-record',
    name: 'areaOfResponsibilityBussinessRecord',
    component: () =>
      import(
        /*webpackChunkName:"areaOfResponsibility" */
        // '@/views/jurisdictionSystem/areaOfResponsibility/BussinessRecord.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/record-commerce/Page.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '商业备案'
    }
  },

  // 导入商业备案
  {
    path: '/jurisdictionSystem/bussiness-record-import',
    name: 'areaOfResponsibilityBussinessRecordImport',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        // '@/views/jurisdictionSystem/areaOfResponsibility/BussinessRecordImport.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/record-commerce/Import.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '导入商业备案',
      breadcrumb: [
        {
          title: '商业备案',
          name: 'areaOfResponsibilityBussinessRecord'
        }
      ]
    }
  },

  // 关联关系维护-sass
  {
    path: '/jurisdictionSystem/relation-page',
    name: 'masterDataSystemRelationPage',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemIncidenceRelationPage" */
        // '@/views/masterDataSystem/relation/page.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/relation/Page.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '关联关系维护'
    }
  },

  // 关联关系维护操作日志-sass
  {
    path: '/masterDataSystem/relation/operation-log',
    name: 'masterDataSystemRelationOperationLog',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemIncidenceRelationImport" */
        // '@/views/masterDataSystem/relation/OperationLog.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/relation/Log.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '操作日志',
      breadcrumb: [
        {
          title: '关联关系维护',
          name: 'masterDataSystemRelationPage'
        }
      ]
    }
  },

  // 关联关系维护导入-sass
  {
    path: '/masterDataSystem/relation-import/:json',
    name: 'masterDataSystemRelationImport',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemIncidenceRelationImport" */
        // '@/views/masterDataSystem/relation/import.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/relation/Import.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '导入关联关系',
      breadcrumb: [
        {
          title: '关联关系维护',
          name: 'masterDataSystemRelationPage'
        }
      ]
    }
  },

  // 数据关系维护
  {
    path: '/jurisdictionSystem/data-relation-page',
    name: 'masterDataSystemDataRelationPage',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemIncidenceRelationPage" */
        // '@/views/masterDataSystem/data-relation/page.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/data-relation/Page.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '数据关系维护'
    }
  },

  // 数据关系维护操作日志
  {
    path: '/masterDataSystem/data-relation-operationlog',
    name: 'masterDataSystemDataRelationOperationLog',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemIncidenceRelationImport" */
        // '@/views/masterDataSystem/data-relation/OperationLog.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/data-relation/Log.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '操作日志',
      breadcrumb: [
        {
          title: '数据关系维护',
          name: 'masterDataSystemDataRelationPage'
        }
      ]
    }
  },
  // 数据关系维护导入
  {
    path: '/masterDataSystem/data-relation/import/:json',
    name: 'masterDataSystemDataRelationImport',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemIncidenceRelationImport" */
        // '@/views/masterDataSystem/data-relation/import.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/data-relation/Import.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '导入数据关系',
      breadcrumb: [
        {
          title: '数据关系维护',
          name: 'masterDataSystemDataRelationPage'
        }
      ]
    }
  },

  // 三者关系
  {
    path: '/jurisdictionSystem/jurisdiction-manage',
    name: 'jurisdictionManage',
    component: () =>
      import(
        /*webpackChunkName:"jurisdiction" */
        // '@/views/jurisdictionSystem/manage/Index.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '岗位/产品/终端关联'
    }
  },

  // 辖区管理页面 共岗终端备案
  {
    path: '/jurisdictionSystem/share-terminal-record',
    name: 'shareTerminalRecord',
    component: () =>
      import(
        // '@/views/jurisdictionSystem/manage/shareTerminalRecord.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/TerminalRecord.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '共岗终端备案',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 辖区管理页面 市场部关系
  {
    path: '/jurisdictionSystem/marketing-relations-department',
    name: 'marketingRelationsDepartment',
    component: () =>
      import(
        // '@/views/jurisdictionSystem/manage/marketingRelationsDepartment.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/market/Page.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '市场部关系',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 辖区管理页面 市场部关系  批量分配
  {
    path: '/jurisdictionSystem/batch-distribution',
    name: 'batchDistribution',
    component: () =>
      import(
        // '@/views/jurisdictionSystem/manage/batchDistribution.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/market/Distribution.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '批量分配',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        },
        {
          title: '市场部关系',
          name: 'marketingRelationsDepartment'
        }
      ]
    }
  },

  // 辖区管理页面 日志
  {
    path: '/jurisdictionSystem/jurisdiction-manage-log',
    name: 'jurisdictionManageLog',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionLog" */
        // '@/views/jurisdictionSystem/manage/Log.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/Log.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '操作日志',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 三者关系 历史关系备份表
  {
    path: '/jurisdictionSystem/manage-history-detail/:date',
    name: 'jurisdictionSystemManageHistoryRecordDetail',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemManageHistoryRecordDetail" */
        // '@/views/jurisdictionSystem/manage/HistoryRecordDetail'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/history/Page.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '历史关联详情',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        },
        {
          title: '历史关联',
          name: 'jurisdictionSystemManageHistoryRecord'
        }
      ]
    }
  },

  // 岗位/产品/终端关联 -按岗位迁移终端
  {
    path: '/jurisdictionSystem/transfer-for-post',
    name: 'transferForPost',
    component: () =>
      import(
        /*webpackChunkName:"jurisdiction" */
        // '@/views/jurisdictionSystem/transferForPost.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/batch-operation/TransferClient.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '按岗位迁移终端',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 三者关系 变更负责人
  {
    path: '/jurisdictionSystem/change-charge/:clientId/:provinceId/:cityId/:is_pit/:cls',
    name: 'changeCharge',
    component: () =>
      import(
        /*webpackChunkName:"jurisdiction" */
        // '@/views/jurisdictionSystem/manage/ChangeCharge.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/ChangCharge.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '变更负责人',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 三者关系 分配辖区
  {
    path: '/jurisdictionSystem/file-allot/:clientId/:provinceId/:cityId',
    name: 'fileAllot',
    component: () =>
      import(
        /*webpackChunkName:"jurisdiction" */
        // '@/views/jurisdictionSystem/manage/FileAllot.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/DistrJuris.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '分配辖区',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 三者关系 查看历史生效关系
  {
    path: '/jurisdictionSystem/history-relation/:client_id/:client_name/:company_code',
    name: 'HistoryRelation',
    component: () =>
      import(
        /*webpackChunkName:"jurisdiction" */
        // '@/views/jurisdictionSystem/manage/HistoryRelation.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/History.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '查看历史生效关系',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 辖区关系匹配
  {
    path: '/jurisdictionSystem/area-esponsibility-relevance',
    name: 'areaOfResponsibilityRelevance',
    component: () =>
      import(
        /*webpackChunkName:"areaOfResponsibility" */
        // '@/views/jurisdictionSystem/areaOfResponsibility/Relevance.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/juris-relation-match/Page.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '辖区关系匹配'
    }
  },

  // 辖区关系 排除档案设置
  {
    path: '/jurisdictionSystem/exclude-client-setting',
    name: 'excludeClientSetting',
    component: () =>
      import(
        /*webpackChunkName:"areaOfResponsibility" */
        // '@/views/jurisdictionSystem/areaOfResponsibility/ExcludeClientSetting.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/juris-relation-match/ExcludeSetting.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '排除档案设置',
      breadcrumb: [
        {
          title: '辖区关系匹配',
          name: 'areaOfResponsibilityRelevance'
        }
      ]
    }
  },
  // 辖区关系 关系管理
  {
    path: '/jurisdictionSystem/relation-manage',
    name: 'jurisdictionSystemRelationManage',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemRelationManage" */
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/relation-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '关系管理'
    }
  },
  // 关系管理明细
  {
    path: '/jurisdictionSystem/relation-manage/detail/:id',
    name: 'jurisdictionSystemRelationManageDetail',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemRelationManage" */
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/relation-manage/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '关系管理', //二级菜单
      title: '关系数据',
      breadcrumb: [
        {
          title: '关系管理',
          name: 'jurisdictionSystemRelationManage'
        }
      ]
    }
  },

  // 商业备案关系
  {
    path: '/jurisdictionSystem/business-filing-relationship',
    name: 'businessFilingRelationship',
    component: () =>
      import(
        /*webpackChunkName:"areaOfResponsibility" */
        // '@/views/jurisdictionSystem/areaOfResponsibility/Relevance.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/business-filing-relationship/Page.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '商业备案关系'
    }
  },
  // 商业备案关系
  {
    path: '/jurisdictionSystem/business-filing-relationship/batch_operate',
    name: 'batchOperate',
    component: () =>
      import(
        /*webpackChunkName:"areaOfResponsibility" */
        // '@/views/jurisdictionSystem/areaOfResponsibility/Relevance.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/business-filing-relationship/batchOperate.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '批量操作',
      breadcrumb: [
        {
          title: '商业备案关系',
          name: 'businessFilingRelationship'
        }
      ]
    }
  }
]

export default jurisRelationsRouter
